/* Shared wishlist link viewer (B3/v9.1). Opens a full-screen overlay on
   top of the homepage when ?list=handle1:variantId,handle2&name=Tom is
   in the URL — SECURITY: name and handles/variant IDs all come straight
   from the URL, so they are treated as untrusted throughout. The name
   is only ever set via .textContent (never innerHTML), is capped to 30
   chars, and has control characters / angle brackets stripped. Handles
   are capped to 50 and validated purely by fetching
   /products/{handle}.js — anything that doesn't resolve to a real
   product (404/invalid) is silently dropped, never rendered. A variant
   ID is only trusted if it's found in THAT product's own variants list
   (fetched fresh, not inferred from the URL) — any variant ID that
   doesn't belong to its product is discarded and the item is treated as
   if no size were chosen at all. Viewing a shared list only ever READS
   from the network; it never touches the viewer's own wishlist storage. */
(function () {
  function sanitizeName(raw) {
    if (!raw) return '';
    var s = String(raw).slice(0, 30);
    s = s.replace(/[\u0000-\u001F\u007F<>]/g, '');
    return s.trim();
  }

  function formatMoney(cents) {
    var n = parseFloat(cents) / 100;
    if (isNaN(n)) return '';
    return '£' + n.toFixed(2);
  }

  // v10.2: before a variant is picked, show the product's own price
  // (or "From £X" when variants actually differ) rather than leaving
  // the price blank — product.price_min/price_max/price_varies come
  // straight off the /products/{handle}.js payload.
  function formatProductPrice(product) {
    if (product.price_varies) return 'From ' + formatMoney(product.price_min);
    return formatMoney(product.price_min != null ? product.price_min : product.price);
  }

  function cdnResize(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  // v10: trims the catalogue's own branding suffixes off a product title
  // for display in compact card/list contexts — the full title (with
  // suffix) is still what's on the product page itself; this is purely a
  // display trim here and in the wishlist drawer.
  function displayTitle(title) {
    return String(title || '').replace(/ - (Goblin Wood|Sumthin Wicked) Exclusive$/, '');
  }

  // v10: shows a brief "That list couldn't be found" toast — used for an
  // unknown/expired short-link code and for a malformed code (the app's
  // /l/:code redirect route sends ?sl_invalid=1 for the latter without
  // ever hitting the DB). Reuses the sitewide wishlist toast element
  // rather than a one-off, so there's only one toast implementation.
  function showNotFoundToast() {
    var toast = document.getElementById('gw-wishlist-toast');
    var textEl = document.getElementById('gw-wishlist-toast-text');
    var viewBtn = document.getElementById('gw-wishlist-toast-view');
    if (!toast) return;
    if (viewBtn) viewBtn.hidden = true;
    if (textEl) textEl.textContent = "That list couldn't be found";
    toast.hidden = false;
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        toast.hidden = true;
        if (viewBtn) viewBtn.hidden = false;
      }, 300);
    }, 4000);
  }

  function parseLongListParam(listParam) {
    return listParam.split(',')
      .map(function (raw) {
        var trimmed = raw.trim();
        if (!trimmed) return null;
        var parts = trimmed.split(':');
        var handle = parts[0];
        var variantId = null;
        if (parts.length > 1) {
          var n = parseInt(parts[1], 10);
          if (!isNaN(n)) variantId = n;
        }
        return handle ? { handle: handle, variantId: variantId } : null;
      })
      .filter(Boolean)
      .slice(0, 50);
  }

  function init() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }

    if (params.get('sl_invalid') === '1') {
      showNotFoundToast();
      return;
    }

    var shortCode = params.get('sl');
    if (shortCode) {
      fetch('/apps/rewards?type=shared_list&code=' + encodeURIComponent(shortCode))
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (!data || !data.ok) { showNotFoundToast(); return; }
          var entries = (data.items || []).slice(0, 50);
          if (!entries.length) { showNotFoundToast(); return; }
          openOverlay(entries, sanitizeName(data.name), !!data.isChristmas);
        })
        .catch(function () { showNotFoundToast(); });
      return;
    }

    var listParam = params.get('list');
    if (!listParam) return;
    var entries = parseLongListParam(listParam);
    if (!entries.length) return;
    openOverlay(entries, sanitizeName(params.get('name')), false);
  }

  function openOverlay(entries, name, storedIsChristmas) {
    var overlay = document.getElementById('gw-shared-list-overlay');
    var grid = document.getElementById('gw-shared-overlay-grid');
    var loading = document.getElementById('gw-shared-overlay-loading');
    var emptyEl = document.getElementById('gw-shared-overlay-empty');
    var titleEl = document.getElementById('gw-shared-overlay-title');
    var subheadingEl = document.getElementById('gw-shared-overlay-subheading');
    var template = document.getElementById('gw-shared-overlay-item-template');
    var actionsEl = document.getElementById('gw-shared-overlay-actions');
    var addAllBtn = document.getElementById('gw-shared-overlay-addall');
    var startOwnBtn = document.getElementById('gw-shared-overlay-startown');
    var closeBtn = document.getElementById('gw-shared-overlay-close');
    if (!overlay || !grid || !template) return;

    var wishlistLabels = (window.gwWishlist && window.gwWishlist.labels) ? window.gwWishlist.labels() : { xmas: false };
    // A list created as a Christmas list reads as one even if viewed
    // slightly outside the season window (storedIsChristmas), same as it
    // was when shared; otherwise today's season still applies for a
    // legacy ?list= link, which never carried that flag.
    var isXmas = storedIsChristmas || wishlistLabels.xmas;
    // .textContent only — name is untrusted URL input, never rendered as HTML.
    // v10.1: the old no-name fallback ("A wishlist") read oddly on its
    // own as a page heading — replaced with wording that still makes
    // sense with no name attached.
    titleEl.textContent = name
      ? (name + (isXmas ? '’s Christmas list' : '’s wishlist'))
      : (isXmas ? 'Someone’s Christmas list' : 'Someone’s been leaving hints…');
    if (subheadingEl) {
      subheadingEl.textContent = isXmas
        ? "Tap Add to bag on anything you'd like to get them for Christmas."
        : "Tap Add to bag on anything you'd like to get them.";
    }

    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    // v10.1: body gets position:fixed while open (belt-and-braces scroll
    // lock, since overflow:hidden alone can still let iOS Safari
    // rubber-band the page behind it) — that drops the body's own scroll
    // offset, so it's captured here and restored in closeOverlay().
    var lockScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = (-lockScrollY) + 'px';
    document.body.dataset.gwSharedLockScrollY = String(lockScrollY);
    document.body.classList.add('gw-shared-overlay-open');

    // v9.1: tracks which items currently have a valid, in-stock variant
    // ready to add — rebuilt live as pickers change (not just at load),
    // so "Add all available to bag" always reflects the current state.
    var readyItems = []; // { id: variantId, quantity: 1 }

    var fetches = entries.map(function (entry) {
      return fetch('/products/' + encodeURIComponent(entry.handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) { return product ? { product: product, requestedVariantId: entry.variantId } : null; })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (results) {
      loading.hidden = true;
      var any = false;
      results.forEach(function (result) {
        if (!result || !result.product || !result.product.handle) return; // unresolved handle — dropped, never rendered
        var product = result.product;
        any = true;

        // Untrusted URL input: only accept a variant ID that actually
        // belongs to THIS product's own freshly-fetched variant list.
        var resolvedVariant = null;
        if (result.requestedVariantId) {
          for (var i = 0; i < product.variants.length; i++) {
            if (product.variants[i].id === result.requestedVariantId) { resolvedVariant = product.variants[i]; break; }
          }
        }

        var frag = template.content.cloneNode(true);
        var itemRoot = frag.querySelector('.gw-shared-overlay__item');
        var img = frag.querySelector('[data-img]');
        var titleNode = frag.querySelector('[data-title]');
        var badgeNode = frag.querySelector('[data-item-badge]');
        if (badgeNode) badgeNode.hidden = !(window.gwWishlist && window.gwWishlist.isPreorderTag && window.gwWishlist.isPreorderTag(product));
        var priceNode = frag.querySelector('[data-price]');
        var soldoutNode = frag.querySelector('[data-soldout]');
        var addBtn = frag.querySelector('[data-add]');
        var chosenEl = frag.querySelector('[data-chosen-size]');
        var optionsEl = frag.querySelector('[data-options]');
        var chooseBtn = frag.querySelector('[data-choose-size]');
        var bubbleWrap = frag.querySelector('[data-bubble-wrap]');
        var pickedRow = frag.querySelector('[data-picked-row]');
        var pickedText = frag.querySelector('[data-picked-text]');
        var changeBtn = frag.querySelector('[data-change]');

        var image = product.featured_image || (product.images && product.images[0]);
        if (image) {
          img.src = cdnResize(image, 300);
          img.alt = product.title;
        }
        titleNode.textContent = displayTitle(product.title);

        var multiVariant = product.variants && product.variants.length > 1;
        var currentVariant = resolvedVariant || (!multiVariant ? product.variants[0] : null);
        var readyEntry = null;

        function describeVariant(v) {
          if (!product.options || !v) return '';
          var parts = [];
          for (var oi = 0; oi < product.options.length; oi++) {
            var val = v['option' + (oi + 1)];
            // product.options entries are {name, position, values}
            // objects from the AJAX API, not plain strings.
            var optionRaw = product.options[oi];
            var optionName = (optionRaw && typeof optionRaw === 'object' && optionRaw.name) ? optionRaw.name : optionRaw;
            if (val) parts.push(optionName + ': ' + val);
          }
          return parts.join(' · ');
        }

        // v10.1: card height now matches the drawer's pattern — a
        // "Choose size" button expands the bubble row on tap, collapsing
        // back to "Size: L · Change" once picked, instead of always
        // showing every bubble inline (which made multi-variant cards
        // much taller than single-variant ones and threw off row/button
        // alignment). Only wired up when a picker actually gets built
        // below (link didn't already carry a valid variant).
        var hasPicker = multiVariant && !resolvedVariant && window.gwWishlist && window.gwWishlist.buildVariantPicker;

        var bag = null;
        function refresh() {
          if (itemRoot) itemRoot.setAttribute('data-needs-size', (multiVariant && !currentVariant) ? '1' : '0');
          if (hasPicker) {
            if (chooseBtn) chooseBtn.hidden = !!currentVariant;
            if (bubbleWrap && currentVariant) bubbleWrap.hidden = true;
            if (pickedRow) {
              pickedRow.hidden = !currentVariant;
              if (currentVariant && pickedText) pickedText.textContent = describeVariant(currentVariant);
            }
          }
          if (!currentVariant) {
            priceNode.textContent = formatProductPrice(product);
            if (bag) bag.paint();
            if (chosenEl) chosenEl.hidden = true;
            return;
          }
          priceNode.textContent = formatMoney(currentVariant.price);
          if (chosenEl) {
            // Shown only for the resolvedVariant (no-picker) path — never
            // for a single-variant product either way, since its one real
            // variant is Shopify's own "Default Title", which means
            // nothing to a customer and isn't a choice they made.
            var desc = (multiVariant && !hasPicker) ? describeVariant(currentVariant) : '';
            if (desc) { chosenEl.textContent = desc; chosenEl.hidden = false; }
            else { chosenEl.hidden = true; }
          }
          if (bag) bag.paint();
          if (currentVariant.available) {
            readyEntry = { id: currentVariant.id, quantity: 1 };
            readyItems.push(readyEntry);
          }
        }

        // Only built when the link DIDN'T carry a valid variant — an
        // item with one already resolved just shows "Size: L" as plain
        // text (chosenEl, set in refresh() above), never an editable
        // picker too.
        if (hasPicker) {
          var picker = window.gwWishlist.buildVariantPicker(product, null, function (matched) {
            currentVariant = matched;
            if (readyEntry) {
              var idx = readyItems.indexOf(readyEntry);
              if (idx !== -1) readyItems.splice(idx, 1);
              readyEntry = null;
            }
            if (matched && bubbleWrap) bubbleWrap.hidden = true;
            refresh();
          });
          if (picker && optionsEl) optionsEl.appendChild(picker.el);
          if (chooseBtn && bubbleWrap) {
            chooseBtn.addEventListener('click', function () { bubbleWrap.hidden = !bubbleWrap.hidden; });
          }
          if (changeBtn && bubbleWrap) {
            changeBtn.addEventListener('click', function () { bubbleWrap.hidden = false; });
          }
        }

        bag = window.gwWishlist.bindBagButton(addBtn, function () { return currentVariant; });
        refresh();

        grid.appendChild(frag);
      });

      if (!any) {
        emptyEl.hidden = false;
      } else {
        grid.hidden = false;
        actionsEl.hidden = false;
        if (!readyItems.length && addAllBtn) addAllBtn.hidden = true;
      }
    });

    function closeOverlay() {
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('gw-shared-overlay-open');
      var restoreY = parseInt(document.body.dataset.gwSharedLockScrollY || '0', 10);
      document.body.style.top = '';
      delete document.body.dataset.gwSharedLockScrollY;
      window.scrollTo(0, restoreY);
    }

    if (closeBtn) closeBtn.addEventListener('click', closeOverlay);

    if (startOwnBtn) {
      startOwnBtn.addEventListener('click', function () {
        closeOverlay();
        var deck = document.getElementById('tarot-deck');
        if (deck) {
          deck.scrollIntoView({ behavior: (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }

    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        if (!readyItems.length || !window.gwInterceptAddToCartMulti) return;
        addAllBtn.disabled = true;
        var originalText = addAllBtn.textContent;
        var missing = document.querySelectorAll('.gw-shared-overlay__item[data-needs-size="1"]').length;
        window.gwInterceptAddToCartMulti(readyItems)
          .then(function () {
            addAllBtn.disabled = false;
            addAllBtn.textContent = missing
              ? (missing + ' item' + (missing === 1 ? '' : 's') + ' still need' + (missing === 1 ? 's' : '') + ' a size')
              : originalText;
            if (missing) window.setTimeout(function () { addAllBtn.textContent = originalText; }, 4000);
          })
          .catch(function () {
            addAllBtn.disabled = false;
            addAllBtn.textContent = 'Something sold out — try again';
            window.setTimeout(function () { addAllBtn.textContent = originalText; }, 3000);
          });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
